import { closeCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { store } from '../../../../store';
import { getAccountConnected } from '../../../features/Account/store/actions';

/**
 * Launches a popup window and monitors for its closure to refresh connected accounts
 * @param url The URL to open in the popup
 * @returns null
 */
export const launchPopup = (url: string) => {
  // Set popup dimensions relative to screen size
  const width = window.screen.width * 0.75;
  const height = window.screen.height * 0.75;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  const params = `width=${width}, height=${height}, top=${top}, left=${left}, fullscreen=yes, scrollbars=1`;

  // Open the popup
  const newWin = window.open(url, 'Ticket Spot', params);

  if (newWin) {
    // Focus on the popup window
    newWin.focus();

    // Set up interval to check if popup is closed
    const checkInterval = setInterval(() => {
      if (newWin.closed) {
        // When popup closes, refresh account connections
        store.dispatch(getAccountConnected()).then(() => store.dispatch(closeCurrentModalAction()));

        // Clear the interval
        clearInterval(checkInterval);
      }
    }, 1000); // Check every second
  }

  return null;
};
